import emailjs from '@emailjs/browser';
import { useRef, useState } from 'react';
import { useForm } from 'react-hook-form';

const initialValues = {
  name: '',
  email: '',
  title: '',
  message: '',
};

const ContactMe = () => {
  const form = useRef();
  const [message, setMessage] = useState({
    display: false,
    message: '',
    type: '',
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: initialValues,
  });

  const toggleAlert = (message, type) => {
    setMessage({ display: true, message, type });
    setTimeout(() => {
      setMessage({ display: false, message: '', type: '' });
    }, 5000);
  };

  const onSubmit = async (data) => {
    try {
      const response = await emailjs.send(
        process.env.VITE_SERVICE_ID,
        process.env.VITE_TEMPLATE_ID,
        {
          name: data.name,
          email: data.email,
          title: data.title,
          message: data.message,
        },
        {
          publicKey: process.env.VITE_PUBLC_KEY,
        }
      );

      if (response.status === 200) {
        toggleAlert('Thank you for your message', 'success');
      }

    } catch (e) {
      console.error(e);
      toggleAlert('Uh oh. Something went wrong. Try again later', 'danger');
    } finally {
      reset();
    }
  };

  return (
    <>
      <div className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl. bvcx mb-3 mx-auto text-center">
          <h2 className="font-nunito text-5xl sm:text-6xl lg:text-7xl font-light text-gray-900 mb-6 tracking-tight leading-tight">
            Let's Get in touch
          </h2>
          <p className="font-nunito text-lg text-gray-600 max-w-2xl mx-auto">
            Questions, collaborations or just a hello.
          </p>
        </div>

        <div className="max-w-3xl mx-auto p-10 sm:p-12 lg:p-16 ">
          <form ref={form} onSubmit={handleSubmit(onSubmit)} noValidate>
            <div className="mb-5">
              <label
                htmlFor="name"
                className="font-nunito mb-3 block text-base font-medium text-[#07074D]"
              >
                Full Name
              </label>
              <input
                type="text"
                name="name"
                id="name"
                placeholder="Full Name"
                className="font-nunito w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#C025D3] focus:shadow-md"
                {...register('name', {
                  required: {
                    value: true,
                    message: 'Please enter your name',
                  },
                  maxLength: {
                    value: 30,
                    message: 'Please use 30 characters or less',
                  },
                })}
              />
              {errors.name && (
                <span className="text-sm text-[#bf1650]">
                  {errors.name.message}
                </span>
              )}
            </div>

            {/* Email */}
            <div className="mb-5">
              <label
                htmlFor="email"
                className="font-nunito mb-3 block text-base font-medium text-[#07074D]"
              >
                Email
              </label>
              <input
                type="email"
                name="email"
                {...register('email', {
                  required: true,
                  pattern:
                    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*/,
                })}
                id="email"
                placeholder="example@domain.com"
                className="font-nunito w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#C025D3] focus:shadow-md"
              />
              {errors.email && (
                <span className="text-sm text-[#bf1650]">
                  Please enter a valid email address
                </span>
              )}
            </div>

            <div className="mb-5">
              <label
                htmlFor="title"
                className="font-nunito mb-3 block text-base font-medium text-[#07074D]"
              >
                Subject
              </label>
              <input
                type="text"
                name="title"
                {...register('title', {
                  required: {
                    value: true,
                    message: 'Please enter a subject',
                  },
                  maxLength: {
                    value: 75,
                    message: 'Subject cannot exceed 75 characters',
                  },
                })}
                id="title"
                placeholder="Enter your subject"
                className="font-nunito w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#C025D3] focus:shadow-md"
              />
              {errors.title && (
                <span className="text-sm text-[#bf1650]">
                  {errors.title.message}
                </span>
              )}
            </div>

            <div className="mb-5">
              <label
                htmlFor="message"
                className="font-nunito mb-3 block text-base font-medium text-[#07074D]"
              >
                Message
              </label>
              <textarea
                rows="4"
                name="message"
                {...register('message', {
                  required: true,
                })}
                id="message"
                placeholder="Type your message"
                className="font-nunito w-full resize-none rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#C025D3] focus:shadow-md"
              ></textarea>
              {errors.message && (
                <span className="text-sm text-[#bf1650]">
                  Please enter a message
                </span>
              )}
            </div>
            <div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="font-nunito w-full sm:w-auto hover:shadow-form rounded-md hover:bg-[#7BF2BC] bg-[#C025D3] py-2.5 px-6 sm:py-3 sm:px-8 text-sm sm:text-base font-semibold text-white outline-none transition-all disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {!isSubmitting ? 'Submit' : 'Submitting...'}
              </button>
            </div>
          </form>
          {message.display && (
            <div className="font-nunito text-green-700">
              <div
                className={`alert alert-${message.type} alert-dismissible mt-5`}
                role="alert"
              >
                {message.message}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ContactMe;
